export const SET_POIS = "SET_POIS";
export const SET_AMENITIES = "SET_AMENITIES";
export const SET_POIS_LOADED = "SET_POIS_LOADED";
export const INIT_POIS = "INIT_POIS";
export const GET_POIS = "GET_POIS";
export const GET_POI = "GET_POI";
export const GET_AMENITIES = "GET_AMENITIES";
export const GET_POIS_LOADED = "GET_POIS_LOADED";
